module.exports = __webpack_public_path__ + "static/img/PLACEHOLDER.a0910e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b122/PLACEHOLDER.png
// module id = o+HK
// module chunks = 0